// @ts-nocheck
import clsx from 'clsx'
import {FC} from 'react'
import {Row} from 'react-table'
import {User} from '../../core/_models'
import {useNavigate} from 'react-router-dom'
import useAuthorization from '../../../../../../hooks/useAuthorization'
import {TooltipWrapper} from '../../../../../../components/Tooltip'
import {useListView} from '../../core/ListViewProvider'
import {downloadFilePDF} from '../../core/_requests'

type Props = {
  row: Row<User>
}
// eslint-disable-next-line react-hooks/rules-of-hooks

const CustomRow: FC<Props> = ({row}) => {
  const id = String(row.original.id) as string
  const {setItemIdForUpdate, setItemIdForUpdateLog, setItemIdForUpdatePdf, setPaymentLog} =
    useListView()

  const isAuthorizedToFranchiseInvoicesView = useAuthorization('franchiseInvoices.view')

  const handleToEdit = () => {
    setItemIdForUpdate(id)
  }

  const handleToLog = () => {
    setItemIdForUpdateLog(id)
  }

  const handleToEditPdf = () => {
    setItemIdForUpdatePdf(id)
  }

  const handlePaymentLog = (dataPaymentLog: any) => {
    setPaymentLog(dataPaymentLog)
  }

  return (
    <tr {...row.getRowProps()}>
      {row.cells.map((cell) => {
        return (
          <td
            {...cell.getCellProps()}
            className={clsx({'text-end min-w-100px': cell.column.id === 'actions'})}
          >
            {cell.render('Cell')}
          </td>
        )
      })}

      <td className='text-center min-w-120px'>
        {isAuthorizedToFranchiseInvoicesView && (
          <>
            <TooltipWrapper tooltipText={'Visualizar'} tooltipPlacement={'top'}>
              <button
                className='btn btn-link btn-color-muted btn-active-color-danger'
                onClick={() => handleToEdit()}
              >
                <i className='ki-duotone ki-book-open me-3 fs-1'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                  <span className='path3'></span>
                  <span className='path4'></span>
                </i>
              </button>
            </TooltipWrapper>
            <TooltipWrapper tooltipText={'Registro de eventos '} tooltipPlacement={'top'}>
              <button
                className='btn btn-link btn-color-muted btn-active-color-danger'
                onClick={() => handleToLog()}
              >
                <i className='ki-duotone ki-time me-3 fs-1'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              </button>
            </TooltipWrapper>

            <TooltipWrapper tooltipText={'Baixar PDF'} tooltipPlacement={'top'}>
              <button
                type='button'
                className='btn btn-sm  btn-link btn-color-muted btn-active-color-danger'
                onClick={() => handleToEditPdf()}
              >
                <i className='ki-duotone ki-file-down fs-1'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              </button>
            </TooltipWrapper>
            {(row.original?.payments?.length ?? 0) > 0 && (
              <TooltipWrapper tooltipText={'Tentativas de cobranças'} tooltipPlacement={'top'}>
                <button
                  type='button'
                  className='btn btn-sm  btn-link btn-color-muted btn-active-color-danger'
                  onClick={() => handlePaymentLog(row.original.payments)}
                >
                  <i className='ki-duotone ki-credit-cart fs-1'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                  </i>
                </button>
              </TooltipWrapper>
            )}
          </>
        )}
      </td>
    </tr>
  )
}
export {CustomRow}
